/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'

const DynamicServiceLayout = ({ title, layout, content, images }) => {
  const { t } = useTranslation()
  const renderImages = (images) => {
    return Object.keys(images).reduce((ret, key) => {
      ret[
        key
      ] = `<img key=${key} src=${images[key].src} alt=${images[key].alt} class="${images[key].className}"/>`
      return ret
    }, {})
  }

  console.log(layout)

  const renderLayout = () => {
    const imagesHTML = renderImages(images)

    let renderedLayout = layout
      // eslint-disable-next-line react/prop-types
      .replace('{{title}}', t(title))
      .replace('{{content}}', t(content))

    Object.keys(images).forEach((key) => {
      renderedLayout = renderedLayout.replace(`{{${key}}}`, imagesHTML[key])
    })

    return <div dangerouslySetInnerHTML={{ __html: renderedLayout }} />
  }

  return <div>{renderLayout()}</div>
}

export default DynamicServiceLayout
